import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";

import { setCurrentUser, logoutUser } from "./actions/authActions";
import { Provider } from "react-redux";
import store from "./store";

import Navbar from "./components/layout/Navbar";
import Landing from "./components/layout/Landing";
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import PrivateRoute from "./components/private-route/PrivateRoute";
import Dashboard from "./components/dashboard/Dashboard";
import Categories from "./components/categories/Categories";
import Stories from "./components/stories/Stories";
import AddStoryData from "./components/addstorydata/AddStoryData";
import Resources from "./components/resources/Resource";
import StoryDataList from "./components/stories/StoryDataList";
import ResourceDataList from "./components/resources/ResourceDataList";
import ResourceAllList from "./components/resources/ResourceAllList";

import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";

// Check for token to keep user logged in
if (localStorage.jwtToken) {
  // Set auth token header auth
  const token = localStorage.jwtToken;
  setAuthToken(token);
  // Decode token and get user info and exp
  const decoded = jwt_decode(token);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));
  // Check for expired token
  const currentTime = Date.now() / 1000; // to get in milliseconds
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());

    // Redirect to login
    window.location.href = "./login";
  }
}
class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Navbar />
            <Route exact path="/" component={Landing} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/login" component={Login} />
            <Switch>
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
              <PrivateRoute exact path="/categories" component={Categories} />
              <PrivateRoute exact path="/stories" component={Stories} />
              <PrivateRoute exact path="/add-data" component={AddStoryData} />
              <PrivateRoute exact path="/resources" component={Resources} />
              <PrivateRoute exact path="/storydatalist" component={StoryDataList} />
              <PrivateRoute exact path="/resourcedatalist" component={ResourceDataList} />
              <PrivateRoute exact path="/resourcealllist" component={ResourceAllList} />
            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}
export default App;
